export function maskPhoneNumber(phone: string): string {
  if (!phone) return '';

  const cleaned = phone.replace(/\s|-/g, '');

  if (cleaned.length <= 4) {
    return cleaned;
  }

  const firstTwo = cleaned.slice(0, 2);
  const lastTwo = cleaned.slice(-2);
  const stars = '*'.repeat(cleaned.length - 4);

  return `${firstTwo}${stars}${lastTwo}`;
}

export function maskEmail(email: string): string {
  if (!email) return '';

  const [localPart, domain] = email.split('@');
  if (!domain) return email;

  const firstChar = localPart.charAt(0);

  const domainParts = domain.split('.');
  if (domainParts.length < 2) {
    return `${firstChar}${'*'.repeat(localPart.length - 1)}@${'*'.repeat(domain.length)}`;
  }

  const secondLevel = domainParts[0];

  const tld = domainParts.slice(1).join('.');

  const maskedSecondLevel = '*'.repeat(secondLevel.length);
  const maskedLocalPart = firstChar + '*'.repeat(Math.max(0, localPart.length - 1));

  return `${maskedLocalPart}@${maskedSecondLevel}.${tld}`;
}
